import React, { Component } from "react";

class SaveUpSVG extends React.Component {
  render() {
    return (
      <svg
        className={"svg-container " + this.props.svgClassName}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 16 16"
      >
        <path
          className="svg"
          d="M13.8,3c0,0.4-0.4,0.8-0.8,0.8S12.2,3.4,12.2,3s0.4-0.8,0.8-0.8S13.8,2.6,13.8,3z M10.4,2.2
	C10,2.2,9.6,2.6,9.6,3s0.4,0.8,0.8,0.8s0.8-0.4,0.8-0.8S10.9,2.2,10.4,2.2z M7.9,2.2C7.4,2.2,7.1,2.6,7.1,3s0.4,0.8,0.8,0.8
	c0.4,0,0.8-0.4,0.8-0.8S8.3,2.2,7.9,2.2z M15.5,0H0.6C0.3,0,0,0.3,0,0.6c0,0.1,0,0.1,0,0.2l0,0v2c0,0.3,0.3,0.6,0.6,0.6
	s0.6-0.3,0.6-0.6V1.2h13.8l0,13.7h-1.4c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6h2c0.3,0,0.6-0.3,0.6-0.6V0.6C16,0.2,15.8,0,15.5,0z
	 M8.1,5.8h-1v2.4h1V5.8z M9.1,5.4h-7v3.3h7V5.4z M10.5,16H0.7C0.3,16,0,15.7,0,15.3V5.5c0-0.4,0.3-0.7,0.7-0.7h9.8
	c0.4,0,0.7,0.3,0.7,0.7v9.8C11.3,15.7,10.9,16,10.5,16z M9.5,10.3H1.8v4.8h7.7V10.3z"
        />
      </svg>
    );
  }
}

export default SaveUpSVG;



// WEBPACK FOOTER //
// ./src/svg/SaveUpSVG.jsx